<template>
  <div
    class="full-screen-video-wrapper"
    @touchstart.passive="tryUnmute"
    @click.passive="tryUnmute"
  >
    <!-- 关闭按钮：阻止事件冒泡 -->
    <div class="close-btn" @click.stop="goBack">✕</div>
    <!-- muted -->
    <!-- 视频容器 -->
    <div class="video-container">
      <video
        ref="videoPlayer"
        :src="src"
        autoplay
        playsinline
        webkit-playsinline
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        @error="onError"
        @contextmenu.prevent
        @play="onPlay"
      ></video>
    </div>

    <!-- 声音提示（仅当静音时显示） -->
    <div v-if="showUnmuteHint" class="unmute-hint" @click.stop="tryUnmute">
      🔊 点击开启声音
    </div>
  </div>
</template>

<script>
export default {
  name: "FullScreenVideo",
  props: {
    src: {
      type: String,
      required: true,
      validator(value) {
        return value && (value.endsWith(".mp4") || value.endsWith(".webm"));
      },
    },
  },
  data() {
    return {
      showUnmuteHint: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      const video = this.$refs.videoPlayer;
      if (!video) return;

      // 初始静音以确保 autoplay 成功
      video.muted = true;
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            this.showUnmuteHint = true; // 播放成功但静音，提示开启声音
          })
          .catch((err) => {
            console.warn("自动播放失败:", err);
            this.showUnmuteHint = true;
          });
      }
    });
  },
  methods: {
    tryUnmute() {
      const video = this.$refs.videoPlayer;
      if (video && video.muted) {
        video.muted = false;
        this.showUnmuteHint = false;
      }
    },
    onPlay() {},
    onError(e) {
      console.error("视频加载失败:", this.src, e);
      this.$emit("error", e);
    },
    goBack() {
      this.$emit("goBack");
    },
  },
};
</script>

<style scoped>
/* 全屏容器 */
.full-screen-video-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: #000;
  z-index: 9999;
  overflow: hidden;
  cursor: pointer;
}

/* ✅ 修复横屏视频的关键：全屏 Flex 容器 + object-fit: contain */
.video-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: #000; /* 黑底填充黑边 */
}

.video-container video {
  width: 100%;
  height: 90vh;
  object-fit: contain; /* ✅ 保持原始比例，完整显示 */
  display: block;
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  top: max(2.1333vw, env(safe-area-inset-top));
  right: max(2.1333vw, env(safe-area-inset-right));
  z-index: 10000;
  width: 5.333vw;
  height: 5.333vw;
  border-radius: 50%;
  background: #ffffff70;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3.2vw;
  font-weight: bold;
  cursor: pointer;
  touch-action: manipulation;
  user-select: none;
  transform: translateZ(0);
  will-change: transform;
}

/* 开启声音提示 */
.unmute-hint {
  position: absolute;
  bottom: 10vw;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 2.666vw 5.333vw;
  border-radius: 5.333vw;
  font-size: 3.733vw;
  cursor: pointer;
  user-select: none;
  z-index: 9998;
}
</style>
